(function () {
  const nav = document.getElementById("mkNav");
  if (!nav) return;

  const toggleBtn = document.getElementById("mkNavToggle");
  const closeBtn  = document.getElementById("mkNavClose");
  const drawer    = document.getElementById("mkNavDrawer");
  const backdrop  = document.getElementById("mkNavBackdrop");

  const navLinks = nav.querySelectorAll("[data-mk-nav-link]");

  function setOpen(open) {
    nav.setAttribute("data-mk-open", open ? "true" : "false");

    if (toggleBtn) toggleBtn.setAttribute("aria-expanded", open ? "true" : "false");
    if (drawer) drawer.hidden = !open;
    if (backdrop) backdrop.hidden = !open;

    document.documentElement.style.overflow = open ? "hidden" : "";
    document.body.style.overflow = open ? "hidden" : "";
  }

  if (toggleBtn) {
    toggleBtn.addEventListener("click", function () {
      const isOpen = nav.getAttribute("data-mk-open") === "true";
      setOpen(!isOpen);
    });
  }

  if (closeBtn) closeBtn.addEventListener("click", () => setOpen(false));
  if (backdrop) backdrop.addEventListener("click", () => setOpen(false));

  navLinks.forEach((a) => a.addEventListener("click", () => setOpen(false)));

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") setOpen(false);
  });

  // تمييز الرابط الحالي
  const path = (window.location.pathname || "/").replace(/\/+$/, "") || "/";
  nav.querySelectorAll("a[data-mk-nav-link]").forEach((a) => {
    const href = (a.getAttribute("href") || "/").replace(/\/+$/, "") || "/";
    if (href === path) a.setAttribute("aria-current", "page");
    else a.removeAttribute("aria-current");
  });

  setOpen(false);
})();